// extracted by mini-css-extract-plugin
export default {"like":"_1V4p5","not-clickable":"_182KK","notClickable":"_182KK","likebutton":"_2-tF6","likes":"_3ioRY"};